module.exports = __webpack_public_path__ + "static/media/features-break-2.6ef5ee88.png";